import styled, { css } from "styled-components";

import StyledContainer from "style/styledContainer";
import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "hooks/redux/hooks";
import { Column, Row } from "style/preset";
import BaseBtnCom from "components/BaseBtnCom";
import { setSwapLoading, setSwapStatus } from "hooks/redux/slices/swapSlice";

import { ReactComponent as WarnSvg } from 'assets/svgs/waring_icon.svg' 
import { ReactComponent as GreenRightSvg } from 'assets/svgs/green_right.svg' 
import { ReactComponent as ErrorSvg } from 'assets/svgs/error_icon.svg'
import { PulseLoader } from "react-spinners";


const TranLoadingWin = () => {
  const { swapLoading, swapStatus } = useAppSelector((state) => state.swap)
  const dispatch = useAppDispatch()

  const fnClose = useCallback(() => {
    dispatch(setSwapLoading(false))
    dispatch(setSwapStatus(0))
  }, [dispatch])

  const showCurStatusStep1 = useCallback(() => {
    if(swapStatus < 1) {
      return {
        // before: <StyledContainer $fontSize="12px" $lineHeight="14px" $color="#767A7F">loader</StyledContainer>,
        before: <PulseLoader
          color="#95a3be"
          cssOverride={{}}
          loading={true}
          margin={2}
          size={4}
          speedMultiplier={1}
        />,
        after: <SwapStatusWrap $state="pending">In progress</SwapStatusWrap>
      }
    } else if(swapStatus <= 2 || swapStatus === 100) {
      return {
        before: <GreenRightSvgWrap></GreenRightSvgWrap>,
        after: <SwapStatusWrap $state="success">Completed</SwapStatusWrap>
      }
    } else {
      if(swapStatus >= 99) {
        return {
          before: <ErrorSvgWrap $isError={true}></ErrorSvgWrap>,
          after: <SwapStatusWrap  $state="failed">Failed</SwapStatusWrap>
        }
      }
    }

    return {}
  }, [swapStatus])

  const showCurStatusStep2 = useCallback(() => {
    if(swapStatus < 2) {
      return {
        // before: <StyledContainer $fontSize="12px" $lineHeight="14px" $color="#767A7F">loader</StyledContainer>,
        before: <PulseLoader
          color="#95a3be"
          cssOverride={{}}
          loading={true}
          margin={2}
          size={4}
          speedMultiplier={1}
        />,
        after: <SwapStatusWrap $state="pending">In progress</SwapStatusWrap>
      }
    } else if(swapStatus === 2) {
      return {
        before: <GreenRightSvgWrap></GreenRightSvgWrap>,
        after: <SwapStatusWrap $state="success">Completed</SwapStatusWrap>
      }
    } else {
      if(swapStatus === 99) {
        return {
          before: <ErrorSvgWrap $isError={false}></ErrorSvgWrap>,
          after: <SwapStatusWrap>Not applicable</SwapStatusWrap>
        }
      }
      if(swapStatus === 100) {
        return {
          before: <ErrorSvgWrap $isError={true}></ErrorSvgWrap>,
          after: <SwapStatusWrap  $state="failed">Failed</SwapStatusWrap>
        }
      }
    }

    return {}
  }, [swapStatus])

  return (
    <>
      {swapLoading && (
        <LoadingBox>
          <ContentBoxWrap>
            <StyledContainer $fontSize="30px" $lineHeight="1" $fontWeight6 $roobertSemiBold>Transaction has started</StyledContainer>
            <TipsBarWrap $mt="16px" $mb="40px" $isError={swapStatus === 2 ? false : true}>
              <WarnSvgWrap></WarnSvgWrap>
              <StyledContainer $ml="10px">{swapStatus < 2 ? 'Please do not close this window until the transaction is completed': swapStatus === 2 ? 'Transaction has been completed': 'Your transaction has failed'}</StyledContainer>
            </TipsBarWrap>

            <FlowWrap>
              {
                showCurStatusStep1()['before']
              }
              <StyledContainer $width="40px"></StyledContainer>
              <Column>
                <StyledContainer $mb="6px" $fontSize="14px" $lineHeight="1" $color="#767A7F" $roobertRegular>Step 1</StyledContainer>
                <StyledContainer $fontSize="16px" $lineHeight="1" $fontWeight6 $roobertSemiBold>Signing the transaction</StyledContainer>
              </Column>
              <StyledContainer $flex1="1"></StyledContainer>
              {
                showCurStatusStep1()['after']
              }
            </FlowWrap>

            <StyledContainer $height="10px"></StyledContainer>

            <FlowWrap>
              {
                showCurStatusStep2()['before']
              }
              <StyledContainer $width="40px"></StyledContainer>
              <Column>
                <StyledContainer $mb="6px" $fontSize="14px" $lineHeight="1" $color="#767A7F" $roobertRegular>Step 2</StyledContainer>
                <StyledContainer $fontSize="16px" $lineHeight="1" $fontWeight6 $roobertSemiBold>Security proof signing</StyledContainer>
              </Column>
              <StyledContainer $flex1="1"></StyledContainer>
              {
                showCurStatusStep2()['after']
              }
            </FlowWrap>
            <StyledContainer $height="60px"></StyledContainer>
            {
              swapStatus >= 2 ? <>
                <StyledContainer $fontSize="18px" $lineHeight="22px">Your transaction has {
                  swapStatus <= 2 ? 'been completed.' : swapStatus === 99 ? 'failed on step 1.' : 'failed on step 2.'

                }</StyledContainer>
                <StyledContainer $fontSize="18px" $lineHeight="22px">You can initiate a new swap.</StyledContainer>
                <StyledContainer $height="30px"></StyledContainer>
                <BaseBtnCom type="1" title="Swap now" onClick={fnClose}></BaseBtnCom>
              </> : <></>
            }
          </ContentBoxWrap>
        </LoadingBox>
      )}
    </>
  );
};

const PopupWinBg = styled(StyledContainer)`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: 'rgba(10, 10, 10, 0.8)';
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
`

const LoadingBox = styled(PopupWinBg)`
  border-radius: 12px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background-color: rgba(255, 255, 255, 0.92);
  z-index: 90;
`;

const ContentBoxWrap = styled(StyledContainer)`
  width: 450px;
  
`
const WarnSvgWrap = styled(WarnSvg)`
  width: 18px;
  height: 18px;
`

const TipsBarWrap = styled(Row)<{$isError: boolean}>`
  font-size: 14px;
  line-height: 1;
  padding: 8px;
  border-radius: 4px;
  background-color: #FFF3F4;
  display: inline-flex;


  & > div {
    color: #C31D28;
  }

  ${WarnSvgWrap} {
    rect, path {
      fill: #C31D28;
    }
  }

  ${
    ({$isError}) => $isError ? css`

    `:css`
      background-color: #EBFFEC;
      & > div {
        color: #0A0A0A;
      }
      ${WarnSvgWrap} {
        rect, path {
          fill: #0A0A0A;
        }
      }
    `
  }
`

const FlowWrap = styled(Row)`
  padding: 16px 20px;
  border-radius: 9px;
  box-shadow: 0px 10px 32px -4px rgba(24, 39, 75, 0.10), 0px 6px 14px -6px rgba(24, 39, 75, 0.12);
`

const SwapStatusWrap = styled(StyledContainer)<{$state: string}>`
  padding: 8px;
  font-size: 14px;
  line-height: 1;
  border-radius: 4px;

  ${
    ({$state}) => $state === 'pending' ? css`
      background-color: #F6FB79;
    `: $state === 'success' ? css`
      background-color: #99FF9E;
    `: $state === 'failed' ? css`
      background-color: #DF2935;
      color: #ffffff;
    ` : css`
      background-color: #F2F2F2;
    `
  }
`

const GreenRightSvgWrap = styled(GreenRightSvg)`
  width: 18px;
  height: 18px;
`

const ErrorSvgWrap = styled(ErrorSvg)<{$isError: boolean}>`
  width: 18px;
  height: 18px;
  
  rect, path {
    fill: ${({$isError}) => $isError ? '#DF2935': '#8A8E93'}
  }
`

export default TranLoadingWin;
